import { createSvgIcon } from "@mui/material";

// Stroke-style icons for the bulletin detail header, taken from the Phosphor
// set the Figma design uses (24 grid, 2px stroke). The project does not depend
// on Phosphor, so the paths are inlined here.
const stroke = (children: React.ReactNode) => (
  <g
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </g>
);

export const IntersectIcon = createSvgIcon(
  stroke(
    <>
      <circle cx="9" cy="9" r="6" />
      <circle cx="15" cy="15" r="6" />
    </>,
  ),
  "Intersect",
);

export const ArrowsOutIcon = createSvgIcon(
  stroke(
    <>
      <path d="M15 4.5H19.5V9" />
      <path d="M14.25 9.75L19.5 4.5" />
      <path d="M9 19.5H4.5V15" />
      <path d="M9.75 14.25L4.5 19.5" />
      <path d="M19.5 15V19.5H15" />
      <path d="M14.25 14.25L19.5 19.5" />
      <path d="M4.5 9V4.5H9" />
      <path d="M9.75 9.75L4.5 4.5" />
    </>,
  ),
  "ArrowsOut",
);

export const XIcon = createSvgIcon(
  stroke(
    <>
      <path d="M18.75 5.25L5.25 18.75" />
      <path d="M18.75 18.75L5.25 5.25" />
    </>,
  ),
  "X",
);

export const ChatCircleIcon = createSvgIcon(
  stroke(
    <path d="M7.49 19.79A9 9 0 1 0 4.21 16.51L3.04 20.01a.75.75 0 0 0 .95.95L7.49 19.79Z" />,
  ),
  "ChatCircle",
);

export const PencilSimpleIcon = createSvgIcon(
  stroke(
    <>
      <path d="M9 20.25H3.75V15L16.06 2.69L21.31 7.94Z" />
      <path d="M12.75 6L18 11.25" />
    </>,
  ),
  "PencilSimple",
);

export const WarningCircleIcon = createSvgIcon(
  <>
    {stroke(
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7.5V12.75" />
      </>,
    )}
    <circle cx="12" cy="16.13" r="1.13" fill="currentColor" />
  </>,
  "WarningCircle",
);
